import React, { useEffect } from 'react';
import { IntercomProvider } from 'react-use-intercom';
import AppRouter from '@app/site/AppRouter';
import TagManager from 'react-gtm-module';

const Application = React.memo(() => {

	const INTERCOM_APP_ID = 'ds9ml7e2';

	useEffect(() => {
		const tagManagerArgs = {
			gtmId: 'GTM-KBW7GCKK'
		};
		TagManager.initialize(tagManagerArgs);
	}, []);

	return <IntercomProvider appId={INTERCOM_APP_ID}
													 autoBoot
													 autoBootProps={{
														 verticalPadding: 100,
														 horizontalPadding: 40,
													 }}>
		<AppRouter />
	</IntercomProvider>;
});

export default Application;